import { useMemo } from 'react'
import { Heading, Container } from '../../../../components/index.js'
import type { PurchaseBarProps } from './types.js'
import { ProductActions } from '../index.js'
import { useBizProductContext } from '../../BizProductProvider.js'
import ScrollSpyNav from './ScrollSpyNav/index.js'
import { withLayout } from '../../../../shared/Styles.js'

const PurchaseBar = ({ onSpyNavItemClick, totalSavingsSlot }: PurchaseBarProps) => {
  const { product, renderRating } = useBizProductContext()

  const PurchaseBarData = useMemo(() => {
    return product?.payload?.components?.find((item: any) => item.componentKey === 'PurchaseBar')?.data || []
  }, [product?.payload])

  return (
    <div id="purchase-bar" className="sticky left-0 top-0 z-[45] w-full border-b border-[#E4E5E6] bg-white">
      <Container>
        <div className="tablet:justify-between laptop-md:gap-16 tablet:gap-0 tablet:w-full flex flex-wrap items-center gap-[10px]">
          <div className="laptop-md:pt-6 laptop-md:pb-0 min-w-0 flex-1 py-3">
            <Heading size={2} className="line-clamp-2 text-wrap" html={product?.title} />
            <div className="laptop-md:block mt-3 hidden">
              <ScrollSpyNav
                tabs={PurchaseBarData}
                className=""
                renderRating={renderRating}
                onSpyNavItemClick={onSpyNavItemClick}
              />
            </div>
          </div>
          <div className="laptop-md:block hidden shrink-0">
            <ProductActions totalSavingsSlot={totalSavingsSlot} />
          </div>
        </div>
      </Container>
      <Container className="laptop-md:hidden relative">
        <div className="absolute left-0 top-0 h-px w-full bg-[#E4E5E6]"></div>
        <ScrollSpyNav tabs={PurchaseBarData} renderRating={renderRating} onSpyNavItemClick={onSpyNavItemClick} />
      </Container>
    </div>
  )
}

export default withLayout(PurchaseBar)
